/* eslint-disable @typescript-eslint/no-explicit-any */
export const pipe =
  (...fns: Array<(arg: any) => any>) =>
  (x: unknown) =>
    fns.reduce((v, f) => f(v), x)
